/* eslint-disable */

import _ from "lodash";
import Cookies from "js-cookie";
import md5 from "md5";
import * as Sentry from "@sentry/browser";

export const sortDisplayOrder = (arr, key) => {
	try {
		arr.sort((a, b) => {
			return a[key] - b[key];
		});
		return arr;
	} catch (err) {
		console.log(err);
		return arr;
	}
};
export const redirectToErrorPage = () => (window.location.href = "/404.html");

export const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	return result;
};

export const cutString = (str, length) => {
	if (str.length > length) {
		return `${str.substr(0, length)}...`;
	} else {
		return str;
	}
};
//Find common and diffrent key in two jsons
//First agrgument have you want same or diff data
//Second argument will have array of two json
//Third argument will have array of keys which not to be considered in comparision
export const diffAndCommon = (type, objs, ignored) => {
	const diffObject = {};
	Object.keys(objs[0]).map(key => {
		if (ignored.includes(key)) return null;
		const returnType =
			type === "same" ? objs[0][key] === objs[1][key] : objs[0][key] !== objs[1][key];
		if (returnType) {
			diffObject[key] = objs[0][key];
		}
	});

	return diffObject;
};

//Same as diff AndCommon Function, but also checks if array values contains new values or not
export const diffAndCommonTicket = (type, objs, ignored) => {
	const diffObject = {};
	Object.keys(objs[0]).map(key => {
		if (ignored.includes(key)) return null;
		let returnType = false;
		if (type === "same") {
			returnType = objs[0][key] === objs[1][key];
		} else {
			if (Array.isArray(objs[0][key])) {
				const ifFormsChanged = checkArrDuplicate(objs[0][key], objs[1][key]);
				if (ifFormsChanged) {
					returnType = true;
				} else {
					returnType = false;
				}
			} else {
				returnType = objs[0][key] !== objs[1][key];
			}
		}
		if (returnType) {
			diffObject[key] = objs[0][key];
		}
	});

	return diffObject;
};

// Checks if array values contains new values, if there is it returns true and if no new values returns it false
const checkArrDuplicate = (array1, array2) => {
	let newArr = array1.filter(val => !array2.includes(val));
	if (newArr.length === 0) {
		newArr = array2.filter(val => !array1.includes(val));
	}
	if (newArr.length > 0) {
		return true;
	} else {
		return false;
	}
};

//diffAndCommon('same', [data, originalData], []);
export const findCommonElements = (arr1, arr2) => arr1.some(item => arr2.includes(item));

//JavaScript new Date Ordinal (st, nd, rd, th)
export const nth = date => {
	if (date > 3 && date < 21) return "th";
	switch (date % 10) {
		case 1:
			return "st";
		case 2:
			return "nd";
		case 3:
			return "rd";
		default:
			return "th";
	}
};

export const removeDuplicateArrayElements = (obj1, obj2, key) => {
	const arr1 = obj1[key];
	const arr2 = obj2[key];
	let newArray = [];
	newArray = arr1.filter(val => !array2.includes(val));
	return newArray;
};

export const deBouncingFunction = function (func, delay, cancel = false) {
	let timer;
	return function (...args) {
		const context = this;
		clearInterval(timer);
		if (cancel) return;
		timer = setTimeout(() => {
			func.apply(context, args);
		}, delay);
	};
};

export function replaceEmptyStringsWithNull(obj) {
	for (const key in obj) {
		if (typeof obj[key] === "object" && obj[key] !== null) {
			// Recursively call if the object is not null
			if (Object.keys(obj[key]).length === 0) {
				// If the object is empty, delete it
				// delete obj[key];
				if (key === "Sequence Number") {
					delete obj[key];
				}
			} else {
				replaceEmptyStringsWithNull(obj[key]);
			}
		} else if (obj[key] === "") {
			// Replace empty strings with null
			obj[key] = null;
		}
	}
}

export const imagesModuleNo = {
	event_poster: 1,
	user_profile: 2,
	featured_events: 3,
	resources: 4,
	past_events: 5,
	codeops: 6,
	community: 7,
	speakers: 8,
	sponsors: 9,
	workshops: 10,
	checkin_app: 11,
	branding_images: 12,
	partners: 13,
	exhibitors: 14
};

//prevent background scroll when a modal is open
export const toggleBodyScroll = isOpen => {
	if (isOpen) {
		document.body.style.overflow = "hidden"; // Disable scroll
	} else {
		document.body.style.overflow = "unset"; // Enable scroll
	}
};

export const regexToValidate = {
	nameRegex: /^[a-zA-Z0-9-:()[\]|,#/<>.&@+! ]+$/,
	urlRegExp: /^[a-zA-Z0-9-]+$/,
	emojiRegex: /[^\u0000-\u007F]+/
};

export const APIStatusCode = {
	STATUS_CODE_SUCCESS: 200,
	STATUS_CODE_CREATED: 201,
	STATUS_CODE_DELETED: 204,
	STATUS_CODE_BAD_REQUEST: 400
};

export const uploadFileSizes = {
	tenMB: 10 * 1024 * 1024, //10 MB
	twentyMB: 20 * 1024 * 1024, // 20 MB
	fiftyMB: 50 * 1024 * 1024 // 50 MB
};

export const isBetaTagRequired = name => {
	const betaItems = ["AI Photo Booth"]; // List of items requiring the Beta tag
	return betaItems.includes(name);
};
export const getPaymentType = (paymentMethod, type = "pg_number") => {
	const PAYMENT_METHOD_TYPES = {
		1: "upi",
		2: "cards",
		3: "net_banking",
		4: "stripe_cards",
		5: "wallet"
	};

	if (type == "pg_number") {
		// To return the payment method number (eg: 1, 2, 3 etc.)
		return Object.keys(PAYMENT_METHOD_TYPES).find(
			key => PAYMENT_METHOD_TYPES[key] === paymentMethod
		);
	} else if (type == "pg_type_name") {
		// To return the payment method string (eg: upi, cards etc.)
		return Object.values(PAYMENT_METHOD_TYPES).find(
			values => values === PAYMENT_METHOD_TYPES[paymentMethod]
		);
	}
};

/// THIS CODE IS FOR SENRTY LOGGED ERRORS

/// --- User Context ---
export const userId = Cookies.get("userEmail")
	? md5(Cookies.get("userEmail").toLowerCase().trim())
	: "";

if (Cookies.get("userEmail")) {
	Sentry.setUser({
		id: userId,
		email: Cookies.get("userEmail")
	});
}

// --- Helper: sanitize sensitive data ---
export const sanitizeData = data => {
	if (!data) return data;
	const clone = { ...data };
	delete clone?.password;
	delete clone?.token;
	delete clone?.jwtToken;
	return clone;
};

// --- Capture Exception ---
export const captureError = (error, context = {}) => {
	Sentry.captureException(error, context);
};

// --- Add Breadcrumb ---
export const addApiBreadcrumb = error => {
	Sentry.addBreadcrumb({
		category: "api.response.error",
		message: `API Error: ${error?.config?.method?.toUpperCase()} ${error?.config?.url}`,
		level: "error",
		data: {
			status: error?.response?.status,
			url: error?.config?.url,
			method: error?.config?.method,
			requestData: sanitizeData(error?.config?.data),
			responsePayload: error?.response?.data
		}
	});
};

// --- Generic Logger ---
export const logApiErrorToSentry = (error, context = {}) => {
	const { status, url, method, requestData, responsePayload, userId } = context;

	if ([500, 403, 401].includes(status || 0)) {
		captureError(error, {
			tags: {
				service: "axios",
				api_url: url,
				http_method: method,
				status_code: status
			},
			extra: {
				requestData: sanitizeData(requestData),
				responsePayload,
				userId
			}
		});
	}
};

//this is for WABA template name
export const formatTemplatesName = (name) => {
	if (!name) return "";

	return name
		.replace(/attach_\d+/gi, "") // remove attach_x
		.replace(/_/g, " ") // replace underscores with spaces
		.replace(/\s+/g, " ") // normalize extra spaces
		.trim()
		.replace(/\b\w/g, (char) => char.toUpperCase()); // Title case
};

export const logSentryMessage = (message, context = {}) => {
	Sentry.captureMessage(message, {
		level: context?.level || "warning",
		extra: sanitizeData(context?.extra || {}),
		tags: context?.tags || {}
	});
};
